import React, { useState, useEffect } from 'react';
import './Dashboard.css'; // Ensure the CSS is updated as well

const Dashboard = () => {
  // Dummy data for user and appointments
  const [userInfo, setUserInfo] = useState({
    name: 'John Doe',
    email: 'john.doe@example.com',
    phone: '123-456-7890',
    profilePicture: 'https://via.placeholder.com/150', // Placeholder image
    bio: 'Avid fitness enthusiast, passionate about maintaining a healthy lifestyle.',
  });

  const [appointments, setAppointments] = useState([
    {
      id: 1,
      doctor: 'Dr. Smith',
      date: '2025-04-21',
      time: '10:30 AM',
      status: 'Confirmed',
      department: 'Cardiology',
      location: 'Room 301, 2nd Floor',
    },
    {
      id: 2,
      doctor: 'Dr. Lee',
      date: '2025-05-05',
      time: '02:00 PM',
      status: 'Pending',
      department: 'Orthopedics',
      location: 'Room 205, 1st Floor',
    },
  ]);

  const [recentActivities, setRecentActivities] = useState([
    { id: 1, activity: 'Scheduled a follow-up for April 21st', date: '2025-04-15' },
    { id: 2, activity: 'Checked appointment status for May 5th', date: '2025-04-10' },
  ]);

  const [healthTips, setHealthTips] = useState([
    'Drink at least 8 cups of water daily.',
    'Regular physical activity can help manage stress and improve overall health.',
    'Eating a balanced diet is essential for long-term wellness.',
  ]);

  // Handle appointment cancellation
  const handleCancelAppointment = (id) => {
    setAppointments((prevAppointments) =>
      prevAppointments.filter((appointment) => appointment.id !== id)
    );
  };

  return (
    <div className="dashboard-page">
      <div className="container">
        <h2>Welcome, {userInfo.name}</h2>

        {/* User Profile Section */}
        <section className="user-profile">
          <div className="profile-info">
            <img src={userInfo.profilePicture} alt="Profile" className="profile-picture" />
            <div>
              <h3>{userInfo.name}</h3>
              <p><strong>Email:</strong> {userInfo.email}</p>
              <p><strong>Phone:</strong> {userInfo.phone}</p>
              <p><strong>Bio:</strong> {userInfo.bio}</p>
            </div>
          </div>
        </section>

        {/* Upcoming Appointments Section */}
        <section className="appointments">
          <h3>Your Upcoming Appointments</h3>
          {appointments.length > 0 ? (
            <ul className="appointment-list">
              {appointments.map((appointment) => (
                <li key={appointment.id} className="appointment-item">
                  <div>
                    <h4>{appointment.doctor}</h4>
                    <p><strong>Department:</strong> {appointment.department}</p>
                    <p><strong>Date & Time:</strong> {appointment.date} at {appointment.time}</p>
                    <p><strong>Location:</strong> {appointment.location}</p>
                    <p>Status: <span className={appointment.status === 'Confirmed' ? 'status-confirmed' : 'status-pending'}>{appointment.status}</span></p>
                  </div>
                  <button
                    className="btn-cancel"
                    onClick={() => handleCancelAppointment(appointment.id)}
                  >
                    Cancel Appointment
                  </button>
                </li>
              ))}
            </ul>
          ) : (
            <p>No upcoming appointments.</p>
          )}
        </section>

        {/* Recent Activities Section */}
        <section className="recent-activities">
          <h3>Your Recent Activities</h3>
          <ul>
            {recentActivities.map((activity) => (
              <li key={activity.id}>
                <p><strong>{activity.activity}</strong> - <span>{activity.date}</span></p>
              </li>
            ))}
          </ul>
        </section>

        {/* Health Tips Section */}
        <section className="health-tips">
          <h3>Health Tips</h3>
          <ul>
            {healthTips.map((tip, index) => (
              <li key={index}>
                <p>{tip}</p>
              </li>
            ))}
          </ul>
        </section>

        {/* Logout Button */}
        <section className="logout-section">
          <button className="btn-logout">Logout</button>
        </section>
      </div>
    </div>
  );
};

export default Dashboard;
